import { createContext } from "react";
import {
  AppInfo,
  Environment,
  GlobalConfiguration,
  LabelObject,
  MappedField,
  MarketingCampaign,
  NewApplication,
  Product,
  QuickLinkObject,
  Tenant,
  Transaction,
  Widget,
  AgentObject,
  Version,
  Property,
  DataBranding,
  Permission,
  Functionality
} from "../interfaces";
import { IdataRoleResponse } from "../interfaces/roles.interface";

interface User {
  name: string;
  lastname: string;
  userId: string;
  avatarURL?: string;
}

export interface AppStateProps {
  user: User | null;
  language: string;
  isLoading: boolean;
  selectedApp: AppInfo | null;
  selectedConfig?: GlobalConfiguration | null;
  selectedProduct?: Product | null;
  selectedTransaction?: Transaction | null;
  selectedMappedField?: MappedField | null;
  selectedLabel?: LabelObject | null;
  selectedQuickLink?: QuickLinkObject | null;
  selectedCampaign?: MarketingCampaign | null;
  selectedWidget?: Widget | null;
  selectedAgent?: AgentObject | null;
  selectedApplication?: NewApplication | null;
  selectedEnvironment?: Environment | null;
  selectedTenant?: Tenant | null;
  selectedVersion?: Version | null;
  selectedProperty?: Property | null;
  selectedUser?: any;
  selectedConsoleLabel?: any;
  selectedValidationMessagesLabel?: any;
  selectedConfirmationMessagesLabel?: any;
  pageFilter?: any | null;
  pageToolFilter?: any | null;
  toastData?: {} | null;
  location: {
    currentLocation?: string;
    prevLocation?: string;
  };
  expires_in: number;
  timeToExpire: number;
  ip: string;
  cookieKC?: string | null;
  selectedPointsObject?: any;
  selectedScheduleObject?: any;
  activeIndexPoints?: any;
  selectedPointOfAttention?: any;
  dataBrandingObject?: DataBranding;
  defaultDataBranding?: DataBranding;
  activeIndexCatalogue?: any;
  selectedProtocolsObject?: any;
  aditionalBreadcrumb?: any;
  activeIndexRoles?: number;
  selectedRolesObject?: IdataRoleResponse | null;
  selectedPermission?: Permission | null;
  selectedFunctionality?: Functionality | null;
  selectedTenantId?: any;
  tenantId?: any;
  isParentTenant?: boolean;
  isMainTenant?: boolean;
  tenantParentName?: string;
  tenantIdListsNavigations: string[];
  appRoles: any;
  showChangeAppButton: boolean;
  showChangeClientButton: boolean;
  tenantAuth: string;
  reloadQuickLinks: boolean;
  tenants?: Tenant[];
  edit?: boolean;
  hasApplications?: boolean,
  selectedApplicationRoles?: any,
  selectedManagementRoles?: any,
  applicationRolesDataFormated?: any,

  selectedUserRoleInfo: any;
  selectedRole: any;
  tokenExpireTime: number;
  refreshToken: boolean;
  activateAlert: boolean;
  keepAlive: boolean;
  sessionTimeOut: number;
  functionalityCode: string;
  permissiondInfoByRole: {
    CREATE: boolean,
    READ: boolean,
    UPDATE: boolean,
    REMOVE: boolean,
  };
  refreshRolePermissions: boolean;
  infoObjRolesByTenantState?: any;
  errorLabelsList?: any;
  labelsImportProcessed?: number;
  errorConfigsList?: any;
  configsImportProcessed?: number;
  childrenTenants?: any;
  aliasParentTenant?: string;
  adminRoleId?: string;
}

interface ContextValues {
  t: Function;
  toast: React.MutableRefObject<any>;
  appState: AppStateProps;
  setAppState: React.Dispatch<React.SetStateAction<AppStateProps>>;
}

export const AppContext = createContext<ContextValues>({} as ContextValues);
